<template>

  <div>
    <register></register>
    <login></login>
  </div>
</template>

<script>
import login from "@/components/login";

import Register from "@/components/register";
export default {
  components: {Register,login}
}

</script>

<style scoped>

</style>